import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminSpotPrices = lazy(() => import("@/pages/admin/AdminSpotPrices"));

export const Route = createFileRoute("/admin/spotpriser")({
  component: () => <AdminSpotPrices />,
});
